import React, { useCallback } from 'react';
import { dispatcher } from 'dispatcher';
import { useTranslations } from 'js/hooks/i18n';
import { withPortlet } from 'js/components/system/Portlet';
import { useGetErrorMessage } from 'js/hooks/server/hooks';
import { componentService } from 'js/services/component.service';
import { useShowNotification } from 'js/components/common/Notifications';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import { changePassword } from './actions';
import { CHANGE_PASSWORD } from './constants';
import ChangePasswordForm from './ChangePasswordForm';

export const ChangePasswordBare = () => {
    const prefix = 'playtech.mobile.system.changePass.';
    const translate = useTranslations(prefix);
    const showNotification = useShowNotification({
        tKey: `${prefix}successMessage`,
        iconType: 'info'
    });
    const getErrorMessage = useGetErrorMessage({ translate });

    const submitHandler = useCallback(async ({ newPassword, oldPassword }) => {
        try {
            await changePassword({ newPassword, oldPassword });
            showNotification();
        } catch (error) {
            const { data = {} } = error?.response || error || {};
            const { errorCode } = data;

            if (errorCode === 303) {
                dispatcher.dispatch('app:message', {
                    ID: 'twoFactorAuthentication',
                    data: {
                        onCancel: () => {
                            publicEventsAPIService.trigger('2fa-popup-closed', 'change-password');
                        },
                        onSuccess: async () => {
                            await changePassword({ newPassword, oldPassword });
                            showNotification();
                        },
                        resendHandler: () => changePassword({ newPassword, oldPassword })
                    }
                });

                return;
            }

            return getErrorMessage(error);
        }
    }, [showNotification, getErrorMessage]);

    return <ChangePasswordForm onSubmit={submitHandler} t={translate} />;
};

export const ChangePassword = withPortlet({ forLoggedIn: true })(ChangePasswordBare);

componentService.registerPageComponents({ [CHANGE_PASSWORD]: ChangePassword });
